import { render, staticRenderFns } from "./ModalsManagement.vue?vue&type=template&id=2f217938&scoped=true&"
import script from "./ModalsManagement.vue?vue&type=script&lang=js&"
export * from "./ModalsManagement.vue?vue&type=script&lang=js&"
import style0 from "./ModalsManagement.vue?vue&type=style&index=0&id=2f217938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f217938",
  null
  
)

export default component.exports